<div class="module-menu" *ngIf="items().length > 1">
  <a *ngFor="let item of items()"
     [routerLink]="item.route"
     [class]="activeSlug === item.slug ? 'module-menu-item active' : 'module-menu-item'">
    <span class="module-menu-icon"><i [class]="item.icon"></i></span>
    <span class="module-menu-copy">
      <strong>{{ item.title }}</strong>
      <small>{{ item.summary }}</small>
    </span>
  </a>
</div>
